<template>
    <a-modal :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose" width="65%">
        <a-form layout="vertical" ref="ruleForm" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
            <!-- <div > -->
                <div class="hidden">
                <a-form-item label="ID主键" name="id">
                    <a-input v-model:value="form.id" placeholder="请输入ID主键" />
                </a-form-item><a-form-item label="项目ID" name="projectId">
                    <a-input v-model:value="form.projectId" placeholder="请输入项目ID" />
                </a-form-item><a-form-item label="分类ID" name="classification">
                    <a-input v-model:value="form.classification" placeholder="请输入分类ID" />
                </a-form-item>
            </div>

            <a-row :gutter="20">

                <a-col :span="24">
                    <a-form-item label="项目负责人类型（项目负责人信息，课题负责人信息，申报单位项目负责人，合作单位项目负责人）" name="leaderType">
                        <DictSelect v-if="typeClass" v-model:value="form.leaderType" :dict-name="'leaderType'" style="margin: -5px 0"
                          placeholder="请选择"/>
                        <DictSelect v-else v-model:value="form.leaderType" :dict-name="'leaderType'" style="margin: -5px 0"
                          placeholder="请选择" disabled/>
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="姓名" name="name">
                        <a-input v-model:value="form.name" placeholder="请输入姓名" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="性别" name="sex">
                        <a-radio-group v-model:value="form.sex">
                            <a-radio :value="0">男</a-radio>
                            <a-radio :value="1">女</a-radio>
                        </a-radio-group>
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="出生日期" name="birth">
                        <date-picker v-model:value="form.birth" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="政治面貌" name="politicalOutlook">
                        <DictSelect v-model:value="form.politicalOutlook" :dict-name="'politicalOutlook'" style="margin: -5px 0"
                          placeholder="请选择"/>
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="身份证号" name="idcard">
                        <a-input v-model:value="form.idcard" placeholder="请输入身份证号" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="职务" name="duties">
                        <a-input v-model:value="form.duties" placeholder="请输入职务" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="籍贯" name="nativePlace">
                        <a-input v-model:value="form.nativePlace" placeholder="请输入籍贯" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="民族" name="nation">
                        <a-input v-model:value="form.nation" placeholder="请输入民族" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="工作单位" name="workUnit">
                        <a-input v-model:value="form.workUnit" placeholder="请输入工作单位" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="技术职称" name="technicalTitle">
                        <a-input v-model:value="form.technicalTitle" placeholder="请输入技术职称" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="学术职称" name="academicTitle">
                        <a-input v-model:value="form.academicTitle" placeholder="请输入学术职称" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="学位（最高学历学位）" name="academicDegree">
                        <DictSelect v-model:value="form.academicDegree" :dict-name="'education_background'" style="margin: -5px 0"
                        placeholder="请选择" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="毕业学校" name="graduationSchool">
                        <a-input v-model:value="form.graduationSchool" placeholder="请输入毕业学校" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="毕业年份" name="graduateDate">
                        <year-picker v-model:value="form.graduateDate" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="专业" name="speciality">
                        <a-input v-model:value="form.speciality" placeholder="请输入专业" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="现从事专业" name="nowSpeciality">
                        <a-input v-model:value="form.nowSpeciality" placeholder="请输入现从事专业" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="通讯地址" name="mailAddress">
                        <a-input v-model:value="form.mailAddress" placeholder="请输入通讯地址" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="邮编" name="postalCode">
                        <a-input v-model:value="form.postalCode" placeholder="请输入邮编" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="联系电话" name="telephone">
                        <a-input v-model:value="form.telephone" placeholder="请输入联系电话" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="手机号" name="phone">
                        <a-input v-model:value="form.phone" placeholder="请输入手机号" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="邮箱" name="email">
                        <a-input v-model:value="form.email" placeholder="请输入邮箱" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="传真" name="fax">
                        <a-input v-model:value="form.fax" placeholder="请输入传真" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="成就（相关研究基础和成果，主要论文或研究成果）" name="achievements">
                        <a-textarea v-model:value="form.achievements" placeholder="成就（相关研究基础和成果，主要论文或研究成果）" :auto-size="{minRows:3,maxRows:6}" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="概述（负责人情况概述）" name="overview">
                        <a-textarea v-model:value="form.overview" placeholder="概述（负责人情况概述）" :auto-size="{minRows:3,maxRows:6}" />
                    </a-form-item>
                </a-col>
            </a-row>
            <!--可编辑区域 end-->
        </a-form>

    </a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import {formMixin} from "@/mixins";
import DictSelect from "@/components/other/DictSelect";
// import store from '@/store';
import {projectLeader} from "@/api/TechnologieprojekteApply";

export default {
    name: "项目负责人信息",
    components: {DictSelect},

    mixins: [formMixin],
    data() {
        return {
            typeClass: false,
            form: {
                    id: null,
                    projectId: null,
                    classification: null,
                    leaderType: null,
                    name: null,
                    sex: null,
                    birth: null,
                    idcard: null,
                    politicalOutlook: null,
                    duties: null,
                    nativePlace: null,
                    nation: null,
                    workUnit: null,
                    technicalTitle: null,
                    academicTitle: null,
                    academicDegree: null,
                    graduationSchool: null,
                    graduateDate: null,
                    speciality: null,
                    nowSpeciality: null,
                    mailAddress: null,
                    postalCode: null,
                    telephone: null,
                    phone: null,
                    fax: null,
                    email: null,
                    achievements: null,
                    overview: null,
                },
                rules: {
                    id: [],
                    projectId: [
                        dataCheck.required({}),
                    ],
                    classification: [
                        dataCheck.required({}),
                    ],
                    leaderType: [
                        
                    ],
                    name: [
                        dataCheck.required({}),
                    ],
                    sex: [
                        dataCheck.required({type:"number"}),
                    ],
                    birth: [
                        dataCheck.required({}),
                    ],
                    idcard: [
                        dataCheck.required({}),dataCheck.id_num
                    ],
                    politicalOutlook: [
                        dataCheck.required({}),
                    ],
                    duties: [
                        dataCheck.required({}),
                    ],
                    nativePlace: [
                        dataCheck.required({}),
                    ],
                    nation: [
                        dataCheck.required({}),
                    ],
                    workUnit: [
                        dataCheck.required({}),
                    ],
                    technicalTitle: [
                        dataCheck.required({}),
                    ],
                    academicTitle: [
                        dataCheck.required({}),
                    ],
                    academicDegree: [
                        dataCheck.required({}),
                    ],
                    graduationSchool: [
                        dataCheck.required({}),
                    ],
                    graduateDate: [
                        dataCheck.required({}),
                    ],
                    speciality: [
                        dataCheck.required({}),
                    ],
                    nowSpeciality: [
                        dataCheck.required({}),
                    ],
                    mailAddress: [
                        dataCheck.required({}),
                    ],
                    postalCode: [
                        dataCheck.required({}),dataCheck.zip_code
                    ],
                    telephone: [
                        dataCheck.required({}),dataCheck.phone
                    ],
                    phone: [
                        dataCheck.required({}),dataCheck.mobile_phone
                    ],
                    fax: [
                        dataCheck.required({}),
                    ],
                    email: [
                        dataCheck.required({}),
                    ],
                    achievements: [
                        dataCheck.required({}),
                    ],
                    overview: [
                        dataCheck.required({}),
                    ],
                },

        }
    },
    
    computed: {
            submitUrl() {
                return projectLeader.saveOrUpdate
            },
        },
    mounted() {
    },
    methods: {
        postForm(e,m){
            setTimeout(() => {
                this.form.projectId = e,
                this.form.classification = m
                if(m==1||m==0){
                    this.form.leaderType = 1
                }else if(m==2){
                    this.typeClass = true
                }else{
                    this.form.leaderType = 0
                }
            }, 50);
        }
    },
}
</script>
<style scoped lang="less">
</style>
